import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assemblee-add',
  templateUrl: './assemblee-add.component.html',
  styleUrls: ['./assemblee-add.component.scss']
})
export class AssembleeAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
